import {useMatch} from 'react-router-dom'
import {routes} from '@utilities/constants/routes.tsx'

/**
 * Code of the assignment the user is currently looking at, `undefined` anywhere
 * else in the app.
 *
 * `useParams` can't be used here: the chat lives in `PrivateLayout`, which is
 * the parent layout route of `assignments/:code`, and a layout element's route
 * context stops at its own match — the child's `:code` is only visible inside
 * the `<Outlet />`. Matching the path explicitly is what works.
 */
export const useAssignmentCode = () => useMatch(routes.ASSIGNMENT.handle.fullPath)?.params.code
